import { createSelector } from 'reselect';
import { RootState } from '@/models/root-state.model';
import { BffUserConsentsResponse, GigConsents } from '@lucky7ventures/bff-types';

export const mandatoryConsents = [
  GigConsents.PersonalDataProcessing,
  GigConsents.PrivacyAndCookieNotice,
  GigConsents.TermsAndConditions,
];
export const smsEmailConsents = [GigConsents.TextMessage, GigConsents.Email];

export const selectConsents = (state: RootState): BffUserConsentsResponse =>
  state.consents.consents;
export const selectUpdateConsentsLoading = (state: RootState): boolean =>
  state.consents.updateConsentsLoading;
export const selectUpdateConsentsSuccess = (state: RootState): boolean =>
  state.consents.updateConsentsSuccess;
export const selectUpdateConsentsError = (state: RootState): boolean =>
  state.consents.updateConsentsError;

export const selectMandatoryConsents = createSelector(selectConsents, consents =>
  consents.filter(consent => mandatoryConsents.includes(consent.name)),
);

export const selectSmsEmailConsents = createSelector(selectConsents, consents =>
  consents.filter(consent => smsEmailConsents.includes(consent.name)),
);

export const selectIsEmailConsented = createSelector(selectSmsEmailConsents, consents => {
  const consent = consents.find(consent => consent.name === GigConsents.Email);
  return consent?.consented;
});

export const selectIsTextMessageConsented = createSelector(selectSmsEmailConsents, consents => {
  const consent = consents.find(consent => consent.name === GigConsents.TextMessage);
  return consent?.consented;
});

export const selectIsTCConsented = createSelector(selectMandatoryConsents, consents => {
  const consent = consents.find(consent => consent.name === GigConsents.TermsAndConditions);
  return consent?.consented;
});

export const selectIsPPConsented = createSelector(selectMandatoryConsents, consents => {
  const consent = consents.find(consent => consent.name === GigConsents.PrivacyAndCookieNotice);
  return consent?.consented;
});

export const selectIsDRConsented = createSelector(selectConsents, consents => {
  const consent = consents.find(consent => consent.name === GigConsents.DetailsReverification);
  return consent?.consented;
});

export const selectIsMarketingConsented = createSelector(
  selectIsEmailConsented,
  selectIsTextMessageConsented,
  (emailConsented, smsConsented) => emailConsented && smsConsented,
);

export const selectMarketingConsents = createSelector(selectConsents, consents =>
  consents.filter(
    consent => consent.name === GigConsents.Email || consent.name === GigConsents.TextMessage,
  ),
);
